import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import TotalIncomePageUI from './TotalIncomePageUI.js'

class TotalIncomePageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      accountIncomeList: null,
      response: null,
      financialYear: '',
      financialYearList: [],
      checked: false
    }
  }

  render() {
    return (
      <TotalIncomePageUI
        context={this.props.context}
        errorList={this.state.errorList}
        accountIncomeList={this.state.accountIncomeList}
        response={this.state.response}
        financialYear={this.state.financialYear}
        checked={this.state.checked}
        onShowDetailsChange={this.onShowDetailsChange}
        financialYearList={this.state.financialYearList}
        onFinancialYearChange={this.onFinancialYearChange}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  onFinancialYearChange = (option) => {
    let context = this.props.context
    this.setState({ financialYear: option.value })
    this.getIncome(context, option.value)
  }

  componentDidMount() {
    let context = this.props.context
    this.getYears(context)
  }

  getYears(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/years`,
      cacheKey: CacheKeys.Years(),
      callback: this.getYearsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getYearsCallback = (response) => {
    let financialYearList = response.financialYearList.map((years) => {
      return { value: years, label: years }
    })
    this.setState(
      { errorList: response.errorList, financialYearList: financialYearList },
      () => {
        let financialYear = response.currentFinancialYear
        this.getIncome(this.props.context, financialYear)
      }
    )
  }

  getIncome(context, financialYear) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/loans/income/financialYear/${financialYear}`,
      cacheKey: CacheKeys.IncomeYearly(financialYear),
      callback: this.getIncomeCallback,
      ttlInSecs: 60
    })
    cacheManager.getObject2(context)
  }

  getIncomeCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      accountIncomeList: response.accountIncomeList,
      response: response, financialYear: response.financialYear
    })
  }

  onShowDetailsChange = () => {
    let newChecked = !this.state.checked
    CacheManager.setObject(CacheKeys.AccountRepaymentsChecked(), { checked: newChecked })
    this.setState({
      checked: newChecked
    })
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.IncomeYearly(this.state.financialYear))
    // CacheManager.removeObject(CacheKeys.IncomeMonthly(this.state.yearMonth))
    this.setState({ accountIncomeList: null, errorList: null }, () => {
      this.getIncome(this.props.context, this.state.financialYear)
      // this.getIncomeMonthly(this.props.context)
    })
  }
}

export default withRouter(TotalIncomePageSF)
